﻿import React from 'react';

import DynamicFormHelpText from './DynamicFormHelpText';
import DynamicFormLevel1QuestionRow from './DynamicFormLevel1QuestionRow';
import styled from 'styled-components';

import { iconCode } from '../../Style/cssHelpers';
import definitions from '../../Style/LfStyleDefinitions';

import {
    SubQuestionGroup,
    DynamicFormPreamble,
    Level1RowContainer,
    RepeatGroupButton
} from '../Styles/dynamicFormStyles';

export default class DynamicFormSubQuestionGroup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            uniqueKey: 'loaded'
        };
    }



    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        const questionGroup = this.props.questionGroup;

        const groupTitle = questionGroup.title;
        const groupPreamble = questionGroup.preamble;
        const groupQuestions = questionGroup.questions;
        const groupSubQuestions = questionGroup.subQuestionGroups;
        const groupIsRepeatable = questionGroup.repeatable;

        const isRepeated = questionGroup.id in this.props.repeatedInputs;
        const repeatCount = isRepeated
            ? this.props.repeatedInputs[questionGroup.id]
            : 0;

        const repeatButtonTitle = questionGroup.repeatableButtonText
            ? questionGroup.repeatableButtonText
            : questionGroup.title
                ? `Lägg till fler fält för "${questionGroup.title}"`
                : 'Lägg till fler fält';


        const hasChanged = () => {
            setTimeout(() => {
                const newKey = Math.round(Math.random()*10000);
                
                this.setState({
                    uniqueKey: Math.round(newKey)
                })
            },33)
        }

        return (
            <SubQuestionGroup>
                <DynamicFormPreamble>
                    {groupTitle}
                    {groupPreamble}
                    <DynamicFormHelpText
                        questionGroupHelpText={this.props.questionGroup.helpText}
                    />
                </DynamicFormPreamble>

                {groupSubQuestions !== null && groupSubQuestions.length > 0 &&
                    groupSubQuestions.map(group => (
                        <DynamicFormSubQuestionGroup
                            key={group.id}
                            questionGroup={group}
                            questionTypeHandler={QuestionTypeHandler}

                            formInputs={this.props.formInputs}
                            addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                            removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                            removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}

                        />
                    ))
                }

                {groupQuestions !== null && groupQuestions.length > 0 &&
                    groupQuestions.map((group, i) => (
                        <Level1RowContainer
                            key={group.id}
                            noTopMargin={i != 0 && group.subQuestionGroup == null}
                        >
                            <DynamicFormLevel1QuestionRow
                                questionGroup={group}
                                questionTypeHandler={QuestionTypeHandler}
                                isRepeated={false}

                                formInputs={this.props.formInputs}
                                repeatedInputs={this.props.repeatedInputs}

                                addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                                repeatQuestionGroup={this.props.repeatQuestionGroup}
                                removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                            />
                        </Level1RowContainer>
                    ))
                }


                {groupIsRepeatable && !this.props.currentStep && !repeatCount &&
                    <RepeatableRowActions>
                        <RepeatableRowActionAdd
                            href="#"
                            title={repeatButtonTitle}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.repeatQuestionGroup(questionGroup);
                                hasChanged()

                            }}
                    >
                            Lägg till fält
                        </RepeatableRowActionAdd>
                    </RepeatableRowActions>
                }


                {/* repeat question group */}

                {isRepeated && groupQuestions !== null && groupQuestions.length > 0 &&
                    [...Array(repeatCount)].map(
                        (_, i) => (
                            <React.Fragment key={i}>
                                {groupQuestions.map((group, j) => (
                                    <Level1RowContainer
                                        key={this.state.uniqueKey + '_' + group.id}
                                        noTopMargin={j != 0 && group.subQuestionGroup == null}
                                    >
                                        <DynamicFormLevel1QuestionRow
                                            questionGroup={group}
                                            questionTypeHandler={QuestionTypeHandler}
        
                                            isRepeated={true}
                                            repeatCount={i+1}
                                            formInputs={this.props.formInputs}
                                            repeatedInputs={this.props.repeatedInputs}
        
                                            repeatQuestionGroup={this.props.repeatQuestionGroup}
                                            removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                                            addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                            removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                                        />
                                    </Level1RowContainer>
                                ))}
                                <RepeatableRowActions>
                                    <RepeatableRowActionDelete
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const repeatableIndex = (i+1);
                                            this.props.removeRepeatedQuestionGroup(questionGroup, repeatableIndex);
                                            hasChanged()
                                        }}
                                    >

                                        Ta bort fält
                                    </RepeatableRowActionDelete>
                                    {i === repeatCount-1 && (
                                        <RepeatableRowActionAdd
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.repeatQuestionGroup(questionGroup);
                                                hasChanged()
                                            }}
                                        >
                                            Lägg till fält
                                        </RepeatableRowActionAdd>
                                    )}
                                </RepeatableRowActions>
                            </React.Fragment>
                        )
                    )
                }
            </SubQuestionGroup>
        );
    }
}


const RepeatableRowActions = styled.div`
    text-align: right
`;
const RepeatableRowAction = styled.a`
    display: inline-block;
    margin-left: 10px;
    text-decoration: underline;
    position: relative;
    padding-right: 22px;
    font-size: 14px;
    line-height: 17px;

    &:after {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        color: #fff;
        width: 15px;
        height: 15px;

        border-radius: 50%;
        text-align: center;
        line-height: 19px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        transform: translate(0, -50%);

        ${iconCode.plus()}
    }
    &:focus,
    &:hover {
        color: initial;
        text-decoration: none;
    }
`;
const RepeatableRowActionAdd = styled(RepeatableRowAction)`
    color: ${definitions.colors.green};
    font-weight: bold;
    font-size: 14px;
    &:after {
        background-color: ${definitions.colors.green};
    }
    &:focus,
    &:hover {
        color: ${definitions.colors.green};
    }
`;
const RepeatableRowActionDelete = styled(RepeatableRowAction)`
    color: #EF3C76;
    &:after {
        background-color: #EF3C76;
        transform: translate(0, -50%) rotate(-45deg);
    }
    &:focus,
    &:hover {
        color: #EF3C76;
    }
`;